import React from 'react'
import Column from '../../../bootstrap/component/Column'
import Row from '../../../bootstrap/component/Row'
import ContentBox from '../../../layout/component/ContentBox'
import { lifecycle } from 'recompose'
import currentUserHasAccess from '../../../../util/widget-helper'
import { CUSTOMER_TRANSFER_DRIVE_FILES_WIDGET } from '../../../process/ui-definition/process-ui'


const TransferDriveFiles = ({ task, fileList, getScanFolderContent }) => {
    if (!currentUserHasAccess(CUSTOMER_TRANSFER_DRIVE_FILES_WIDGET)) {
        return null
    }

    const { processInstance } = task
    const { context } = processInstance
    const { driveFolderId } = context
    return (
        <ContentBox title="Drive Files">
            <Row>
                <Column>
                    <button
                        className="btn btn-primary btn-sm"
                        onClick={() => {
                            getScanFolderContent(driveFolderId)
                        }}>
                        <i className="fa fa-refresh"/>
                    </button>
                </Column>
            </Row>

            <Row>
                <Column>
                    <table className="customer-form-table">
                        <thead>
                            <tr>
                                <th>File</th>
                            </tr>
                            {fileList.map(file => {
                                return (
                                    <tr key={file.id}>
                                        <td>{file.name}</td>
                                    </tr>)
                            })}
                        </thead>
                        <tbody>
                        </tbody>
                    </table>
                </Column>
            </Row>
        </ContentBox>
    )
}


TransferDriveFiles.propTypes = {}

export default lifecycle({
    componentDidMount () {
        const { processInstance } = this.props.task
        const { context } = processInstance
        const { driveFolderId } = context
        this.props.getScanFolderContent(driveFolderId)
    },
})(TransferDriveFiles)




// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/TransferDriveFiles.js